<template>
  <div
    class="spinner-item d-flex align-center justify-center"
    :class="{'is-dud': isDud}"
  >
    <div v-if="!isDud && !noBg" class="backdrop" :style="backdropStyles" />
    <img :src="image" class="image">
    <div v-if="!isDud" class="price text-center">
      <div class="item-price text-h5 green500--text font-weight-black">
        ${{ item.price | toScrap }}
      </div>
    </div>
  </div>
</template>

<script>
const DudImg = require('@/assets/img/games/cases/dud.png')

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
    circular: Boolean,
    noBg: Boolean,
  },
  computed: {
    backdropStyles() {
      const { item, circular } = this

      if (circular) {
        return {
          background: `radial-gradient(circle at center, ${item.color} 25%, transparent 72%)`,
        }
      }

      return {
        background: `radial-gradient(circle at top, ${item.color} 25%, transparent 90%)`,
      }
    },
    isDud() {
      return this.item.id === 'dud'
    },
    image() {
      if (this.isDud) {
        return DudImg
      }

      return `https://community.cloudflare.steamstatic.com/economy/image/${this.item.image}/164x164`
    },
  },
}
</script>


<style lang="scss" scoped>
.spinner-item {
  position: relative;

  .image {
    z-index: 2;
    width: 100%;
    max-width: 92px;
  }

  .backdrop {
    @include overlay;

    z-index: 1;
    opacity: 0.25;
  }

  .price {
    position: absolute;
    z-index: 6;
    top: 50%;
    left: 50%;
    width: 100%;
    opacity: 0;
    transform: translate(-50%, -50%);

    .item-price {
      text-shadow: 0 0 12px black;
    }
  }

  &.is-dud {
    .image {
      opacity: 0.4;
    }
  }
}
</style>
